/**
 * Lean fire-and-forget analytics tracker.
 *
 * Every event is validated on the server against a strict whitelist —
 * this file is just a thin wrapper so components can call one function.
 * Failures are silent so analytics can never break the UI.
 */
import { api } from "@/lib/api";

export function track(event_type, metadata = {}) {
  try {
    // No await — do not block the caller.
    api.post("/analytics/event", { event_type, metadata }).catch(() => {});
  } catch (_) {
    /* noop */
  }
}
